<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="ack01">
<a id="page09"></a>
<div class="chapterHead">
<h2 class="chapterTitle1"><span class="xrefInternal"><a href="#/contents#ack_01"><span class="bold"><em class="italic">Acknowledgements</em></span></a></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText1"><span class="bold">Writing this book,</span> I relied on the hospitality of many. In Brussels, Sarah Lambert provided a home away from home; in Washington Patti Waldmeir welcomed me; in Paris I am indebted to Beatrice Lacoste; and in Geneva my uncle and aunt Mario and Anneke Musacchio were wonderful hosts. In Kinshasa I would have gone mad had it not been for the hospitality and friendship of Serge and Francis.</p>
<p class="para">Journalists are not generally a sharing breed, so I am particularly grateful for help given by Massimo Alberizzi, Marina Rini, Victor Rousseau, Marie France Cros, David Goodhart and Philip Gourevitch. Steve Askins and Carole Collins, experts on Mobutu’s financial arrangements, were kind enough to give me access to their papers. I am grateful to the <em class="italic">Financial Times</em> for funding so many of my African journeys and indulging my bookwriting ambitions. It was a great boon to be able to call on John Caveney, researcher at the <em class="italic">Financial Times</em>, for help.</p>
<p class="para">My friends Iain Pears, Sarah and Juliette Towhidi were supportive throughout. My parents put up with my short temper and <a id="page10"></a>Julian Harty, my computer-wise brother-in-law, kept me operational by salvaging the ruins of my laptop.</p>
<p class="para">I have bounced questions and ideas incessantly off Peter Vandevelde, Arthur Malu Malu, Julie Mukendi and Professor Mabi Mulumba. Their patience and good humour are much appreciated.</p>
<p class="para">I owe particular thanks to the US magazine <em class="italic">Transition</em>. At a time when no one else seemed interested in the project, editor Mike Vazquez was appreciative and enthusiastic, keeping me going when I was in danger of flagging. Edited excerpts from the prologue and chapters eight and twelve were first published in <em class="italic">Transition</em>’s pages.</p>
<p class="para">Lastly, my thanks to Chris McGreal, Christian Jennings, Richard Dowden and, above all, Koert Lindyer, my cherished travelling companions throughout the years in Congo/Zaire.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack01.vue?9023fb0a